import { useInfiniteQuery } from '@tanstack/react-query';
import { apiCall } from '../../lib/api.js';
import { useAccessToken, requireToken } from '../../lib/use-access-token.js';

export interface AdminUserItem {
  id: string;
  entraOid: string;
  entraUpn: string;
  email: string;
  displayName: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface AdminUsersPage {
  items: AdminUserItem[];
  nextCursor: string | null;
}

export function useAdminUsers(options: { search?: string } = {}) {
  const { token } = useAccessToken();
  const search = options.search?.trim() ?? '';
  return useInfiniteQuery({
    queryKey: ['admin-users', search, token] as const,
    enabled: !!token,
    initialPageParam: undefined as string | undefined,
    queryFn: async ({
      pageParam,
      signal,
    }: {
      pageParam: string | undefined;
      signal?: AbortSignal;
    }): Promise<AdminUsersPage> => {
      const url = new URL('/v1/admin/users', window.location.origin);
      if (search) url.searchParams.set('search', search);
      url.searchParams.set('limit', '50');
      if (pageParam) url.searchParams.set('cursor', pageParam);
      return apiCall<AdminUsersPage>(`${url.pathname}?${url.searchParams.toString()}`, {
        token: requireToken(token),
        ...(signal ? { signal } : {}),
      });
    },
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });
}
